export const makeSelectUserIsLogged = (state: AppState) => state.userReducer.isLogged;

export const makeSelectCurrentUser = (state: AppState) => state.userReducer.user;

export const makeSelectAuthorizedStatus = (state: AppState) => state.userReducer.authorizedStatus;
